import React, { FC, useCallback, useState } from "react"
import { Button, DotLoading, SafeArea, Toast } from "antd-mobile"
import styles from "./index.module.less"
import { useDocumentTitle } from "~src/hooks/useDocumentTitle"
import { useGetWelfareRid } from "~src/hooks/useGetWelfareRid"
import { getParticipationDonationInfo, getProjectDonationInfo } from "~src/service/welfare"
import { IDonationInfo } from "~src/service/welfare/welfare"
import useQuery from "~src/hooks/useQuery"
import BlockchainTitle from "./blockchainTitle"
import classnames from "classnames"
import CopyToClipboard from "react-copy-to-clipboard"

const BlockChain: FC = () => {
  const [rid, setRid] = useState<string>("")
  const searchQuery = useQuery()
  const id = searchQuery("id")
  const type = searchQuery("type")
  const [donationInfo, setDonationInfo] = useState<IDonationInfo>({} as IDonationInfo)
  const [loading, setLoading] = useState<boolean>(true)
  useDocumentTitle('区块链电子存证')
  useGetWelfareRid((rid) => {
    setRid(() => rid)
    if (type === "participant") {
      // 查询兑换记录上链信息
      fetchParticipationDonationInfo(rid)
    } else {
      fetchProjectInfo()
    }

  }, [])
  const fetchProjectInfo = async () => {
    try {
      const res = await getProjectDonationInfo(id)
      setDonationInfo(res)
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }
  const fetchParticipationDonationInfo = async (rid: string) => {
    try {
      const res = await getParticipationDonationInfo(id, rid)
      setDonationInfo(res)
    } catch (err) {
    } finally {
      setLoading(false)
    }
  }
  const onLinkCopy = useCallback(() => {
    Toast.show({
      content: <div style={{ textAlign: "center" }}>
        <div>复制成功</div>
        <div>请前往浏览器打开链接</div>
      </div>
    })
  }, [donationInfo])
  return <div className={styles.wrap}>
    <div className={styles.content}>
      <div className={styles.chain} style={{ display: loading ? 'none' : 'block' }}>
        {type === "participant" ? <>
          <div className={styles['chain-item']}>
            <BlockchainTitle title="项目名称：" />
            <div className={classnames(styles['chain-item-value'], styles['chain-item-projectname'])} style={{ background: '#D3F7DE' }}>{donationInfo?.spuName ?? ''}</div>
          </div>
          <div className={classnames(styles['chain-item'], styles['chain-participant'])}>
            <BlockchainTitle title="参与记录：" />
            <div className={styles['chain-item-value']}>
              <div className={styles['chain-userinfo']}>
                <span className={styles['chain-userinfo-label']}>参与人昵称：</span>
                <span className={styles['chain-userinfo-value']}>{donationInfo?.userName}</span>
              </div>
              <div className={styles['chain-userinfo']}>
                <span className={styles['chain-userinfo-label']}>参与人ID：</span>
                <span className={styles['chain-userinfo-value']}>{donationInfo?.userId}</span>
              </div>
              <div className={styles['chain-userinfo']}>
                <span className={styles['chain-userinfo-label']}>助力数额：</span>
                <span>{`${donationInfo?.exchangeNum ?? 0}积分`}</span>
              </div>
              <div className={styles['chain-userinfo']}>
                <span className={styles['chain-userinfo-label']}>参与时间：</span>
                <span>{donationInfo?.exchangeTime}</span>
              </div>
            </div>
          </div>
        </> : <>
          <div className={styles['chain-item']}>
            <BlockchainTitle title="凭证名称：" />
            <div className={classnames(styles['chain-item-value'], styles['chain-item-value-break-none'])}>{donationInfo?.certificationName}</div>
          </div>
          <div className={styles['chain-item']}>
            <BlockchainTitle title="发证机构：" />
            <div className={classnames(styles['chain-item-value'], styles['chain-item-value-break-none'])}>{donationInfo?.issuingAuthority}</div>
          </div>
          <div className={styles['chain-item']}>
            <BlockchainTitle title="凭证信息：" />
            <div className={classnames(styles['chain-item-value'], styles['chain-item-value-break-none'])} dangerouslySetInnerHTML={{ __html: donationInfo?.certificationContent }} />
          </div>
        </>}
        <div className={classnames(styles['chain-item'], styles['chain-split'])}>
          {type === "participant" ? "项目的参与记录都会上传至区块链，永久保护，任何人都无法篡改，保护信息公开透明。" : "本证明已上传至区块链，永久保护，任何人都无法篡改，保护信息公开透明。"}
        </div>
        <div className={styles['chain-item']}>
          <BlockchainTitle title="区块链平台：" />
          <div className={classnames(styles['chain-item-value'], styles['chain-item-bg'])} >{donationInfo?.blockchainPlatform}</div>
        </div>
        <div className={styles['chain-item']}>
          <BlockchainTitle title="存证时间：" />
          <div className={classnames(styles['chain-item-value'], styles['chain-item-bg'])} >{donationInfo?.retainTime}</div>
        </div>
        <div className={styles['chain-item']}>
          <BlockchainTitle title="存证保全ID：" copycontent={donationInfo?.retainId} />
          <div className={classnames(styles['chain-item-value'], styles['chain-item-bg'])} >{donationInfo?.retainId}</div>
        </div>
        <div className={styles['chain-item']}>
          <BlockchainTitle title="验证链接：" copycontent={donationInfo?.verifyLink} />
          <CopyToClipboard text={donationInfo?.verifyLink ?? ''} onCopy={onLinkCopy}>
            <div className={classnames(styles['chain-item-value'], styles['chain-item-bg'])}>{donationInfo?.verifyLink}</div>
          </CopyToClipboard>
        </div>
        <div className={styles['chain-bottom']}>
          <CopyToClipboard text={donationInfo?.retainUrl ?? ''} onCopy={onLinkCopy}>
            <Button fill='none' className={styles['chain-bottom-btn']}>下载《超级链存证保全函》</Button>
          </CopyToClipboard>
        </div>
      </div>
      {loading && <div style={{ fontSize: 14 }} className={styles.loading}>
        <DotLoading />
        <span>数据加载中</span>
      </div>}
    </div>

    <SafeArea position='bottom' />
  </div>
}
export default BlockChain
